import { useTranslation } from "react-i18next";
import { BaseTrueFalseQuestionDto } from "@packages/api/madlenAPI.schemas";
import { Button } from "../../../../../core";

interface TrueFalseQuestionEditorProps {
  question: BaseTrueFalseQuestionDto;
  onQuestionChange: (question: BaseTrueFalseQuestionDto) => void;
}

export const TrueFalseQuestionEditor = ({
  question,
  onQuestionChange,
}: TrueFalseQuestionEditorProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
        {t("assignments.generator.preview.correctAnswer")}
      </label>
      <div className="flex gap-3">
        <Button
          onClick={() =>
            onQuestionChange({
              ...question,
              answer: true,
            })
          }
          size="md"
          rounded="md"
          bgColor={
            question.answer === true
              ? "bg-green-50 dark:bg-green-900/30"
              : "bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600"
          }
          textColor={
            question.answer === true
              ? "text-green-700 dark:text-green-200"
              : "text-gray-700 dark:text-gray-200"
          }
          fullWidth
          variant="outline"
          className={`${
            question.answer === true
              ? "border-green-200 dark:border-green-800"
              : "border-gray-200 dark:border-gray-600"
          }`}
        >
          {t("assignments.generator.preview.true")}
        </Button>
        <Button
          onClick={() =>
            onQuestionChange({
              ...question,
              answer: false,
            })
          }
          size="sm"
          rounded="md"
          bgColor={
            question.answer === false
              ? "bg-red-50 dark:bg-red-900/30"
              : "bg-white hover:bg-red-50 dark:bg-gray-700 dark:hover:bg-gray-600"
          }
          textColor={
            question.answer === false
              ? "text-red-700 dark:text-red-200"
              : "text-gray-700 dark:text-gray-200"
          }
          fullWidth
          variant="outline"
          className={`${
            question.answer === false
              ? "border-red-200 dark:border-red-800"
              : "border-gray-200 dark:border-gray-600"
          }`}
        >
          {t("assignments.generator.preview.false")}
        </Button>
      </div>
    </div>
  );
};
